import { parseISO, setMilliseconds, setMinutes, setSeconds, subMinutes } from "date-fns";

const TARGET_DEPARTURE_BUFFER_IN_MINUTES = 5;

/**
 * Calculates the departure time for a shift based on the computed arrival data.
 *
 * Logic:
 * 1. Subtracts the travel duration and buffer from the target arrival time
 * 2. Floors the minutes to the nearest 5-minute interval
 * 3. Resets seconds and milliseconds to 0
 *
 * This ensures workers have a consistent departure time with a safety buffer,
 * rounded to convenient 5-minute intervals.
 */
export function getDepartureTimeForShift(computedArrival: {
  targetArrivalTime: string;
  durationInMinutes: number;
}): Date {
  const targetArrivalDate = parseISO(computedArrival.targetArrivalTime);

  const departure = subMinutes(
    targetArrivalDate,
    computedArrival.durationInMinutes + TARGET_DEPARTURE_BUFFER_IN_MINUTES
  );

  // Floor minutes to nearest 5
  const flooredMinutes = departure.getMinutes() - (departure.getMinutes() % 5);

  return setMilliseconds(setSeconds(setMinutes(departure, flooredMinutes), 0), 0);
}
